import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ProDriverReviewListItem = ResultOf<
  typeof proDriverReviewListQuery
>["proDriverReviews"]["data"][number];

export const proDriverReviewListQuery = graphql(`
  query ProDriverReviewList($first: Int!, $page: Int!, $proDriverId: ID) {
    proDriverReviews(first: $first, page: $page, pro_driver_id: $proDriverId) {
      data {
        id
        comment
        rating
        created_at
        updated_at
        reviewedBy {
          id
          name
          profilePicture {
            ...MediaFields
          }
        }
        workOrderAssignment {
          id
          workOrder {
            id
            reference
          }
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
